// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:29:13

export default {
  "id": "sprunki-memory-card-match",
  "slug": "sprunki-memory-card-match",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/8a8434cb07b44b5db5596d5538c1afce-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/8a8434cb07b44b5db5596d5538c1afce/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Sprunki Memory Card Match",
      "description": "Put your memory to the ultimate test with Sprunki Memory Card Match! Dive into a world of fun and challenge as you flip cards to reveal and match delightful Sprunki characters, scenes, and surprises. Perfect for kids and adults alike, this game combines entertainment with brain-boosting fun!\nChallenge yourself or compete with friends to see who has the sharpest memory. With Sprunki Memory Card Match, every flip is a step closer to unlocking fun surprises and reaching the top!",
      "instructions": "Mouse click or tap to play",
      "genres": [
        "Puzzle",
        "Quiz"
      ],
      "tags": [
        "boys",
        "girls",
        "matching",
        "memory",
        "school"
      ]
    },
    "zh-CN": {
      "title": "精灵记忆卡配对",
      "description": "用Sprunki记忆卡配对游戏挑战你的记忆力极限！沉浸在充满乐趣和挑战的世界中，翻动卡片揭示并匹配可爱的Sprunki角色、场景和惊喜。适合儿童和成人，这款游戏将娱乐与提升大脑乐趣相结合！\n\n挑战自己或与朋友竞技，看谁的记忆力更敏锐。在Sprunki记忆卡配对游戏中，每一次翻动都是解锁乐趣惊喜、迈向顶峰的一步！",
      "instructions": "鼠标点击或轻触开始游戏",
      "genres": [
        "拼图",
        "问答"
      ],
      "tags": [
        "男孩们",
        "女孩们",
        "配对",
        "记忆",
        "学校"
      ]
    },
    "zh-TW": {
      "title": "Sprunki 記憶卡配對遊戲",
      "description": "將你的記憶力挑戰至極限，與Sprunki記憶卡配對遊戲一較高下！深入一個充滿樂趣和挑戰的世界，翻轉卡片來揭露並匹配令人歡喜的Sprunki角色、場景和驚喜。適合兒童和成人一樣，這款遊戲結合娛樂與提神醒腦的樂趣！挑戰自己或與朋友競賽，看看誰的記憶力最敏捷。透過Sprunki記憶卡配對遊戲，每一次翻轉都是接近解鎖樂趣驚喜和達到頂峰的一步！",
      "instructions": "滑鼠點擊或滑動按鈕開始遊戲",
      "genres": [
        "謎題",
        "問答遊戲"
      ],
      "tags": [
        "男孩們",
        "女孩們",
        "配對",
        "記憶",
        "學校"
      ]
    },
    "zh-HK": {
      "title": "史普林基記憶卡配對",
      "description": "將你的記憶力挑戰至極限，與Sprunki記憶卡配對遊戲一較高下！沉浸在樂趣與挑戰的世界中，翻轉卡片揭露並匹配可愛的Sprunki角色、場景和驚喜。適合小孩和大人一樣玩，這款遊戲結合娛樂與增強腦力的樂趣！挑戰自己或與朋友競賽，看看誰的記憶力最出色。透過Sprunki記憶卡配對遊戲，每一次翻轉都是接近解鎖樂趣驚喜和達到頂峰的一步！",
      "instructions": "鼠標點擊或觸碰以遊玩",
      "genres": [
        "謎題",
        "問答遊戲"
      ],
      "tags": [
        "男孩們",
        "女孩們",
        "配對",
        "記憶",
        "學校"
      ]
    },
    "ja": {
      "title": "スプリンキーメモリーカードマッチ",
      "description": "Sprunki メモリーカード マッチであなたの記憶力を究極の試練に挑戦しましょう！楽しい冒険と挑戦に没頭し、カードをめくることで魅力的なSprunkiキャラクター、シーン、驚きを発見してマッチングを楽しみましょう。子供から大人まで幅広く楽しめるこのゲームは、エンターテインメントと脳を鍛える楽しみを組み合わせています！\n\n自分自身に挑戦したり、友達と競争して誰が最も鋭い記憶力を持っているかを試しましょう。Sprunki メモリーカード マッチであれば、毎回のめくることは楽しい驚きを解禁する一歩に近づくことになります！",
      "instructions": "マウスクリックまたはタップで遊ぶ",
      "genres": [
        "パズル",
        "クイズ"
      ],
      "tags": [
        "みなさん",
        "女の子たち",
        "一致",
        "記憶",
        "学校"
      ]
    },
    "ko": {
      "title": "스프랑키 메모리 카드 매치",
      "description": "스프런키 메모리 카드 매치로 기억력을 최대한 테스트하세요! 카드를 뒤집어 즐거운 스프런키 캐릭터, 풍경, 놀라운 발견을 맞추는 재미와 도전을 경험하세요. 어린이와 성인 모두에게 적합한 이 게임은 엔터테인먼트와 뇌력 향상을 동시에 제공합니다!\n자신을 도전하거나 친구들과 경쟁하여 가장 뛰어난 기억력을 확인하세요. 스프런키 메모리 카드 매치에서는 매번 카드를 뒤집으면 재미있는 놀라운 발견을 해결하고 최상위에 오는 데 가까워집니다!",
      "instructions": "마우스 클릭이나 탭하여 게임 시작",
      "genres": [
        "퍼즐",
        "퀴즈"
      ],
      "tags": [
        "아이들",
        "소녀들",
        "매칭",
        "기억력",
        "학교"
      ]
    },
    "fr": {
      "title": "Carte mémoire Sprunki Match",
      "description": "Mettez votre mémoire à l'épreuve avec Sprunki Memory Card Match ! Plongez dans un monde de fun et de défi en retournant des cartes pour révéler et matchez des personnages, des scènes et des surprises delights Sprunki. Idéal pour les enfants et les adultes, ce jeu combine l'entertainment avec du fun qui booste l'esprit ! Défiez-vous ou comprenez avec vos amis pour voir qui a la mémoire la plus affûtée. Avec Sprunki Memory Card Match, chaque retournement est un pas vers l'ouverture de surprises amusantes et la montée au sommet !",
      "instructions": "Clic ou tapotez pour jouer",
      "genres": [
        "Puzzle",
        "Quiz"
      ],
      "tags": [
        "garçons",
        "filles",
        "correspondance",
        "mémoire",
        "école"
      ]
    }
  }
};
